module.exports = __webpack_public_path__ + "img/soh.41332b70.png";